const breakpoints = {
    medium: 450,
    small: 300,
}

export const cssMediaQueryBreakpoints = {
    small: `@media (max-width: ${breakpoints.small}px)`,
    medium: `@media (max-width: ${breakpoints.medium}px)`,
}